import Vue from 'vue';
import Vuex from 'vuex';
import { instance } from '@/utils/ajax';
import sessionTimer from '@/utils/sessionTimer';
import { marketingDataProcessor } from '../utils/marketingDataProcessor';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import orderBy from 'lodash/orderBy';
import qs from 'qs';
import saleEndDateTimer from './saleEndDateTimer';
import { message, getMessage } from '../utils/getMessage';
import startOfDay from 'date-fns/startOfDay';
import parseISO from 'date-fns/parseISO';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: undefined,
        bofUser: undefined,
        profiles: undefined,
        shoppingList: undefined,
        shoppingListPreviewedById: undefined,
        advertisementList: undefined,
        videoAdvertisementList: undefined,
        previewCmpy: undefined,
        teamnoteClientName: undefined,
        cartItems: [],
        lastAddedCartItem: undefined,
        cpnList: [],
        crdtPntBal: 0,
        dfltRcvCrdtPntUnitPchsAmt: undefined,
        dfltRcvCrdtPntUnitQty: undefined,
        dfltSpendCrdtPntUnitQty: undefined,
        dfltSpendCrdtPntUnitDsctAmt: undefined,
        friendAccountMaxProdKinds: undefined,
        salesEndCountDownHour: undefined,
        purchasedProductKeys: [],
        useCoupon: false,
        useCreditPoint: false,
        cpn: undefined,
        creditPoint: undefined,
        orderList: [],
        eventTicketList: [],
        crdtPntHistList: [],
        companySiteList: [],
        companyPaymentMethodList: [],
        enableReferral: false,
        enableReferralTcoinAward: false,
        enableWelcomeTcoinAward: false,
        enableBirthdayTcoinAward: false,
        enableCreditPoint: false,
        showLoginRegisterModal: false,
        fpsQrCode: undefined,
        fpsCurrentOrdNo: undefined,
        fpsCurrentOrdKey: undefined,
        fpsPymtAmt: undefined,
        saleEndDateDistance: undefined,
        popupAdvertisement: undefined,
        showConfirmPhoneNumber: false,
        promotionCampaigns: {
            promotionCampaignCny2021Status: undefined,
            promotionCampaignCny2021FreeSampleCount: undefined
        },
        promotionEvents: [],
        custPrzHistList: [],
        saleCatgRefPrcNameMap: undefined,
        saleCatgUnitPrcNameMap: undefined,
        saleCatgUseTcoinMap: undefined,
        saleCatgPayCashMap: undefined,
        luckydraw2021IndMap: undefined,
        showProdCatgFltr: undefined,
        prodCatgList: undefined,
        geogAreaList: undefined,
        rdmGiftShopList: undefined,
        enblRdmGift: undefined,
        enblCreAcct: undefined
    },
    getters: {
        cartEmpty(state) {
            return state.cartItems.length === 0;
        },
        totalQty() {
            return list => (list || []).reduce((a, p) => a + p.prodOrdQty, 0);
        },
        totalPrice() {
            return list =>
                (list || []).reduce(
                    (a, p) => a + p.prodOrdQty * p.prodUnitPrcAmt,
                    0
                );
        },
        isLessThanOrigPrcAmt() {
            return product =>
                product.prodOrigUnitPrcAmt &&
                product.prodOrigUnitPrcAmt > product.prodUnitPrcAmt;
        },
        cartTotalQty(state, getters) {
            return getters.totalQty(state.cartItems);
        },
        cartTotalPrice(state, getters) {
            return getters.totalPrice(state.cartItems);
        },
        cartStdTotalPrice(state, getters) {
            return getters.totalPrice(
                (state.cartItems || []).filter(c => c.prodTypeCode === 'STD')
            );
        },
        cartSmplTotalPrice(state, getters) {
            return getters.totalPrice(
                (state.cartItems || []).filter(c => c.prodTypeCode === 'SMPL')
            );
        },
        cartChrtyTotalPrice(state, getters) {
            return getters.totalPrice(
                (state.cartItems || []).filter(c => c.prodTypeCode === 'CHRTY')
            );
        },
        cpnDsctAmt(state) {
            return state.useCoupon && state.cpn ? state.cpn.cpnDsctAmt : 0;
        },
        adhocDsctAmt(state) {
            let adhocDsctAmt = 0;

            // CNY New Member 2021 promotion campaign
            if (
                state.promotionCampaigns.promotionCampaignCny2021Status ===
                    'A' &&
                state.promotionCampaigns.promotionCampaignCny2021FreeSampleCount
            ) {
                let rmnFreeSmplProdQty =
                    state.promotionCampaigns
                        .promotionCampaignCny2021FreeSampleCount;
                // Sort by prodUnitPrcAmt in descending order
                const smplCartItems = orderBy(
                    (state.cartItems || []).filter(
                        c => c.prodTypeCode === 'SMPL'
                    ),
                    ['prodUnitPrcAmt'],
                    ['desc']
                );

                for (let i = 0; i < smplCartItems.length; i++) {
                    const cartItem = smplCartItems[i];
                    const freeQty = Math.min(
                        rmnFreeSmplProdQty,
                        cartItem.prodOrdQty
                    );
                    adhocDsctAmt =
                        adhocDsctAmt + freeQty * cartItem.prodUnitPrcAmt;
                    rmnFreeSmplProdQty = rmnFreeSmplProdQty - freeQty;

                    if (rmnFreeSmplProdQty <= 0) {
                        break;
                    }
                }
            }

            return adhocDsctAmt;
        },
        adhocDsctMsgs(state) {
            let msgs = [];

            if (
                state.promotionCampaigns.promotionCampaignCny2021Status ===
                    'A' &&
                state.promotionCampaigns.promotionCampaignCny2021FreeSampleCount
            ) {
                let rmnFreeSmplProdQty =
                    state.promotionCampaigns
                        .promotionCampaignCny2021FreeSampleCount;

                msgs.push({
                    class: 'text-secondary',
                    component: {
                        name: 'message',
                        render(h) {
                            return h(
                                'div',
                                `新會員限時優惠: 首次結帳，頭${rmnFreeSmplProdQty}件「試樣品」貨品免費`
                            );
                        }
                    }
                });
            } else if (
                state.promotionCampaigns.promotionCampaignCny2021Status === 'P'
            ) {
                msgs.push({
                    class: 'text-red',
                    component: {
                        name: 'message',
                        render(h) {
                            return h(
                                message,
                                {
                                    props: {
                                        msgKey: '上一張訂單處理中，請稍候。{0}'
                                    }
                                },
                                [
                                    h(
                                        'router-link',
                                        {
                                            props: {
                                                tag: 'button',
                                                to: { name: 'orderHistory' }
                                            },
                                            class: 'text-blue underline',
                                            slot: 'arg0'
                                        },
                                        ['查詢訂單']
                                    )
                                ]
                            );
                        }
                    }
                });
            }

            return msgs;
        },
        adhocCartCanProcess(state) {
            // 上一張訂單處理中，請稍候。
            if (
                state.promotionCampaigns.promotionCampaignCny2021Status === 'P'
            ) {
                return false;
            }

            return true;
        },
        crdtPntAmt(state) {
            return state.useCreditPoint ? state.creditPoint : 0;
        },
        rcvCrdtPntUnitPchsAmt(state, getters) {
            return (
                getters.shoppingList?.rcvCrdtPntUnitPchsAmt ||
                state.dfltRcvCrdtPntUnitPchsAmt
            );
        },
        rcvCrdtPntUnitQty(state, getters) {
            return (
                getters.shoppingList?.rcvCrdtPntUnitQty ||
                state.dfltRcvCrdtPntUnitQty
            );
        },
        spendCrdtPntUnitQty(state, getters) {
            return (
                getters.shoppingList?.spendCrdtPntUnitQty ||
                state.dfltSpendCrdtPntUnitQty
            );
        },
        spendCrdtPntUnitDsctAmt(state, getters) {
            return (
                getters.shoppingList?.spendCrdtPntUnitDsctAmt ||
                state.dfltSpendCrdtPntUnitDsctAmt
            );
        },
        crdtPntDsctAmt(state, getters) {
            return (
                (getters.crdtPntAmt / getters.spendCrdtPntUnitQty) *
                getters.spendCrdtPntUnitDsctAmt
            );
        },
        maxCrdtPnt(state, getters) {
            return list => {
                const cartTotalPriceAfterCpnDsctAndAdhocDsct = Math.max(
                    getters.canUseCrdtPntTotalAmt(list) -
                        getters.cpnDsctAmt -
                        getters.adhocDsctAmt,
                    0
                );
                const maxCrdtPnt = Math.min(
                    state.crdtPntBal,
                    (cartTotalPriceAfterCpnDsctAndAdhocDsct *
                        getters.spendCrdtPntUnitQty) /
                        getters.spendCrdtPntUnitDsctAmt
                );

                return (
                    Math.floor(maxCrdtPnt / getters.spendCrdtPntUnitQty) *
                    getters.spendCrdtPntUnitQty
                );
            };
        },
        maxCrdtPntDsctAmt(state, getters) {
            return list =>
                Math.floor(
                    getters.maxCrdtPnt(list) / getters.spendCrdtPntUnitQty
                ) * getters.spendCrdtPntUnitDsctAmt;
        },
        cartTotalPriceAfterAllDsct(state, getters) {
            const cartTotalPriceAfterAllDsct =
                getters.cartTotalPrice -
                getters.cpnDsctAmt -
                getters.adhocDsctAmt -
                getters.crdtPntDsctAmt;
            return Math.max(cartTotalPriceAfterAllDsct, 0);
        },
        canEarnCrdtPntTotalAmt(state, getters) {
            return list => {
                return (
                    getters.canUseCrdtPntTotalAmt(list) -
                    getters.cartTotalPrice +
                    getters.cartTotalPriceAfterAllDsct
                );
            };
        },
        crdtPntEarn(state, getters) {
            return list => {
                return (
                    Math.floor(
                        getters.canEarnCrdtPntTotalAmt(list) /
                            getters.rcvCrdtPntUnitPchsAmt
                    ) * getters.rcvCrdtPntUnitQty
                );
            };
        },
        cartCanProcess(state, getters) {
            /*
            2020-04-28
            Note: 1. All product type can use credit point. Five(5) credit points = HKD $1
                  2. Only sample product can use coupon
            */
            if (
                getters.crdtPntDsctAmt +
                    getters.adhocDsctAmt +
                    getters.cpnDsctAmt >
                    getters.cartTotalPrice ||
                getters.cpnDsctAmt > getters.cartSmplTotalPrice
            ) {
                return false;
            }

            if (!getters.adhocCartCanProcess) {
                return false;
            }

            return state.cartItems.every(cart => {
                if (
                    cart.prodUnitPrcAmt === undefined ||
                    cart.prodUnitPrcAmt == null
                ) {
                    return false;
                }
                const maxOrdQty = getters.getProductMaxOrdQtyPerPerson(cart);
                if (
                    maxOrdQty &&
                    maxOrdQty < cart.totalBoughtQty + cart.prodOrdQty
                ) {
                    return false;
                }

                const productActualRemainingQty = getters.productActualRemainingQty(
                    cart
                );
                if (cart.prodOrdQty > productActualRemainingQty) {
                    return false;
                }
                return true;
            });
        },
        isPreviewShoppingListByShopListKey(state) {
            const routeNames = [
                'previewShoppingList',
                'previewShoppingListByGroup',
                'previewShoppingListProduct'
            ];
            return routeNames.some(n => n === state.route.name);
        },
        homePageRoute(state, getters) {
            if (getters.isPreviewShoppingListByShopListKey) {
                return {
                    name: 'previewShoppingList',
                    params: {
                        shopListKey: state.route.params.shopListKey
                    }
                };
            }
            if (getters.previewCmpyToken) {
                return {
                    name: 'previewProducts',
                    params: {
                        cmpyToken: getters.previewCmpyToken
                    }
                };
            }
            return {
                name: 'home'
            };
        },
        productDetailRoute(state, getters) {
            return id => {
                let params = {
                    id
                };
                if (getters.isPreviewShoppingListByShopListKey) {
                    return {
                        name: 'previewShoppingListProduct',
                        params: {
                            ...params,
                            shopListKey: state.route.params.shopListKey
                        }
                    };
                }
                if (getters.previewCmpyToken) {
                    return {
                        name: 'previewProduct',
                        params: {
                            ...params,
                            cmpyToken: getters.previewCmpyToken
                        }
                    };
                }
                return {
                    name: 'product',
                    params: {
                        ...params
                    }
                };
            };
        },
        productGroupRoute(state, getters) {
            return (saleCatgSlctCode, prodCatgSlctKey) => {
                let params = {
                    saleCatgSlctCode,
                    prodCatgSlctKey
                };
                if (getters.isPreviewShoppingListByShopListKey) {
                    return {
                        name: 'previewShoppingListByGroup',
                        params: {
                            ...params,
                            shopListKey: state.route.params.shopListKey
                        }
                    };
                }
                if (getters.previewCmpyToken) {
                    return {
                        name: 'previewProductsByGroup',
                        params: {
                            ...params,
                            cmpyToken: getters.previewCmpyToken
                        }
                    };
                }
                return {
                    name: 'products',
                    params: {
                        ...params
                    }
                };
            };
        },
        shoppingList(state, getters) {
            if (getters.isPreviewShoppingListByShopListKey) {
                return state.shoppingListPreviewedById;
            }
            return state.shoppingList;
        },
        productList(state, getters) {
            const shoppingList = getters.shoppingList;
            return shoppingList ? shoppingList.shopListProdList : [];
        },
        productListBySaleCatgSlctCode: (state, getters) => saleCatgSlctCode => {
            return (getters.productList || []).filter(
                p => p.saleCatgSlctCode === saleCatgSlctCode
            );
        },
        productAdvertisement(state, getters) {
            return getters.productList
                .filter(p => p.prodAdvrtImgId)
                .map(p => ({
                    advrtImgId: p.prodAdvrtImgId,
                    prodAdvrtImgId: p.prodAdvrtImgId,
                    shopListProdKey: p.id,
                    prodKey: p.prodKey,
                    shopListKey: p.shopListKey
                }));
        },
        bannerAdvertisementList(state) {
            return (state.advertisementList || []).filter(
                a => a.advrtTypeCode === 'BANNER'
            );
        },
        mainAdvertisementList(state) {
            return (state.advertisementList || []).filter(
                a => a.advrtTypeCode === 'MAIN'
            );
        },
        inPageAdvertisementList(state) {
            return (state.advertisementList || []).filter(
                a => a.advrtTypeCode === 'INPAGE'
            );
        },
        productLinkList(state, getters) {
            return getters.shoppingList
                ? getters.shoppingList.prodLinkList
                : [];
        },
        previewCmpyToken(state) {
            return state.previewCmpy
                ? state.previewCmpy.cmpyEmailTknNum
                : undefined;
        },
        sampleProductList(state, getters) {
            return getters.productList.filter(p => p.prodTypeCode === 'SMPL');
        },
        standardProductList(state, getters) {
            return getters.productList.filter(p => p.prodTypeCode === 'STD');
        },
        charityProductList(state, getters) {
            return getters.productList.filter(p => p.prodTypeCode === 'CHRTY');
        },
        getSaleCatgList() {
            return items => {
                const itemsWithSaleCatgSlctKeyList = items.filter(
                    p => p.saleCatgSlctKey
                );
                const uniqSaleCatgList = uniqBy(
                    itemsWithSaleCatgSlctKeyList,
                    'saleCatgSlctKey'
                ).map(c => ({
                    saleCatgSlctKey: c.saleCatgSlctKey,
                    saleCatgSlctCode: c.saleCatgSlctCode,
                    saleCatgSlctDesp: c.saleCatgSlctDesp,
                    saleCatgSlctDispSeqNum: c.saleCatgSlctDispSeqNum
                }));
                /*
                if (itemsWithSaleCatgSlctKeyList.length !== items.length) {
                    uniqSaleCatgList.push({
                        saleCatgSlctKey: -1,
                        saleCatgSlctCode: 'OTHER',
                        saleCatgSlctDesp: '其他',
                        saleCatgSlctDispSeqNum: Math.max(
                            ...uniqSaleCatgList.map(i => i.saleCatgSlctDispSeqNum)
                        )
                    });
                }
                */
                const sortedSaleCatgList = sortBy(uniqSaleCatgList, [
                    'saleCatgSlctDispSeqNum',
                    'saleCatgSlctKey'
                ]);
                return sortedSaleCatgList;
            };
        },
        productListSaleCatgList(state, getters) {
            const productList = getters.productList || [];
            return getters.getSaleCatgList(productList);
        },
        productListSaleCatgDisplayList(state, getters) {
            const productList =
                getters.productList.filter(
                    product => product.dispProdInd === 'Y'
                ) || [];
            return getters.getSaleCatgList(productList);
        },
        cartSaleCatgList(state, getters) {
            const cartItems = state.cartItems || [];
            return getters.getSaleCatgList(cartItems);
        },
        orderByOrderNo: state => orderNo => {
            return (state.orderList || []).find(
                o => o.saleOrdTxnNum === orderNo
            );
        },
        confirmedOrderProductList(state) {
            const confirmedOrders = (state.orderList || []).filter(
                o => o.saleOrdStsCode === 'C'
            );

            const confirmedProds = confirmedOrders.reduce((a, c) => {
                return a.concat(
                    (c.saleOrdProdList || []).map(p => ({
                        ...p,
                        saleOrdCreDate: c.saleOrdCreDate
                    }))
                );
            }, []);

            return confirmedProds;
        },
        productActualRemainingQty() {
            return product => {
                const {
                    rmnProdQty,
                    stckAvailQty,
                    pgsProdSaleQtyInd,
                    pgsProdQty,
                    maxProdSaleQty,
                    chkProdInvtryInd
                } = product;
                if (pgsProdSaleQtyInd === 'Y') {
                    return Math.max(
                        pgsProdQty + rmnProdQty - maxProdSaleQty,
                        0
                    );
                }
                if (chkProdInvtryInd === 'N') {
                    return maxProdSaleQty == undefined || maxProdSaleQty == null
                        ? 9999
                        : Math.max(rmnProdQty, 0);
                }
                if (maxProdSaleQty === undefined || maxProdSaleQty === null) {
                    return Math.max(stckAvailQty, 0);
                }
                return Math.max(Math.min(stckAvailQty, rmnProdQty), 0);
            };
        },
        productDisplayFullname() {
            return (product, removeNewLine = false) => {
                const { prodBrndName, prodName, prodSizeText } = product;
                const displayName = (
                    (prodBrndName ? prodBrndName + '\n' : '') +
                    (prodName ? prodName + '\n' : '') +
                    (prodSizeText ? prodSizeText + '\n' : '')
                ).trim();

                return removeNewLine
                    ? displayName.replace(/\n/, ' ')
                    : displayName;
            };
        },
        getCmpySiteById: state => id => {
            return state.companySiteList.find(s => s.id === id);
        },
        getSmplProdMapResult: (state, getters) => product => {
            const prodTypeCode = product.prodTypeCode;

            if (
                !['SMPL', 'STD'].includes(prodTypeCode) ||
                !getters.shoppingList.prodSmplMapList
            ) {
                return undefined;
            }

            const matchProdSmplMap = getters.shoppingList.prodSmplMapList.find(
                psm =>
                    psm[
                        prodTypeCode === 'SMPL' ? 'smplProdKey' : 'stdProdKey'
                    ] === product.prodKey
            );

            const matchProdKey = matchProdSmplMap
                ? matchProdSmplMap[
                      prodTypeCode === 'SMPL' ? 'stdProdKey' : 'smplProdKey'
                  ]
                : 0;

            return matchProdKey > 0
                ? getters.productList.find(p => p.prodKey === matchProdKey)
                : undefined;
        },
        getProdLinksByProdKey: (state, getters) => prodKey => {
            return sortBy(
                getters.productLinkList.filter(pl => pl.prodKey === prodKey),
                'dispSeqNum'
            );
        },
        requireConfirmTermsOfUse(state) {
            return state.user?.custAcctStsCode === 'U';
        },
        isEnterpriseCustomer(state) {
            return state.user?.custTypeCode === 'ENT';
        },
        isFriendCustomer(state) {
            return state.user?.custTypeCode === 'FRND';
        },
        requireConfirmPhoneNumber(state, getters) {
            return (
                getters.isFriendCustomer && state.user?.phoneNumVrfyInd !== 'Y'
            );
        },
        allowInviteFriendMember(state) {
            return state.user?.enblFrndAcctInd === 'Y';
        },
        isShoppingListOpen(state) {
            return state.saleEndDateDistance && state.saleEndDateDistance > 0;
        },
        maxOrdMltpQty(state) {
            return Math.max(state.user?.maxOrdMltpQty || 1, 1);
        },
        getProductMaxOrdQtyPerPerson: (state, getters) => product => {
            // For Friend account, each product can only buy max. 2 Qty.
            // Override if shopping list product’s setting is 3 or above (or no limit).
            if (getters.isFriendCustomer) {
                if (!product.maxCustOrdQty && product.maxCustOrdQty !== 0) {
                    return 2;
                }
                return Math.min(product.maxCustOrdQty, 2);
            }

            return product.maxCustOrdQty
                ? product.maxCustOrdQty * getters.maxOrdMltpQty
                : undefined;
        },
        getCallingOfCompany() {
            return cmpyTypeCode => {
                const key = `calling.of.company.${cmpyTypeCode}`;
                const msg = getMessage(key);
                return msg !== key ? msg : getMessage('calling.of.company');
            };
        },
        getCallingOfCustomer() {
            return cmpyTypeCode => {
                const key = `calling.of.customer.${cmpyTypeCode}`;
                const msg = getMessage(key);
                return msg !== key ? msg : getMessage('calling.of.customer');
            };
        },
        isBeforePromotionEventBeginDate() {
            return prmtEvnt =>
                startOfDay(new Date()).getTime() <
                parseISO(prmtEvnt.prmtEvntBgnDate).getTime();
        },
        isBeforePromotionEventActivityBeginDate() {
            return prmtEvnt =>
                startOfDay(new Date()).getTime() <
                parseISO(prmtEvnt.prmtEvntActvBgnDate).getTime();
        },
        isAfterPromotionEventEndDate() {
            return prmtEvnt =>
                startOfDay(new Date()).getTime() >
                parseISO(prmtEvnt.prmtEvntEndDate).getTime();
        },
        firstRunningPromotionEvent(state, getters) {
            const runningEvents = (state.promotionEvents || []).filter(p => {
                return (
                    !getters.isBeforePromotionEventBeginDate(p) &&
                    !getters.isAfterPromotionEventEndDate(p)
                );
            });
            return orderBy(
                runningEvents,
                ['prmtEvntBgnDate', 'id'],
                ['asc', 'asc']
            )[0];
        },
        getCustPrzHistListByPrmtEvntId(state) {
            return prmtEvntId =>
                (state.custPrzHistList || []).filter(
                    cph => cph.prmtEvntId === prmtEvntId
                );
        },
        saleCatgRefPrcName(state) {
            return product =>
                state.saleCatgRefPrcNameMap?.[product.saleCatgSlctCode] ||
                '參考價';
        },
        saleCatgUnitPrcName(state) {
            return product =>
                state.saleCatgUnitPrcNameMap?.[product.saleCatgSlctCode] ||
                '售價';
        },
        canUseCrdtPntTotalAmt(state) {
            // 2021-09-14 update: only part of the sales category can earn and use credit point
            // 2022-01-18 update: shopping list product with crdtPntEnblInd = 'N' cannot use credit point
            return products => {
                const canUseCrdtPntProdList = products.filter(
                    p =>
                        (p.crdtPntEnblInd ||
                            state.saleCatgUseTcoinMap?.[p.saleCatgSlctCode]) ===
                        'Y'
                );
                return canUseCrdtPntProdList
                    .map(v => v.prodUnitPrcAmt * v.prodOrdQty)
                    .reduce((a, c) => a + c, 0);
            };
        },
        luckydraw2021EarnAmt(state, getters) {
            return products => {
                const earnLuckydrawProdList = products.filter(
                    p =>
                        (p.prmtEvntEnblInd ||
                            state.luckydraw2021IndMap?.[p.saleCatgSlctCode]) ===
                        'Y'
                );
                const earnLuckydrawPymtAmt = earnLuckydrawProdList
                    .map(p => p.prodUnitPrcAmt * p.prodOrdQty)
                    .reduce((a, c) => a + c, 0);
                const canOnlyUseCrdtPntProdList = products.filter(
                    p =>
                        state.luckydraw2021IndMap?.[p.saleCatgSlctCode] !==
                            'Y' &&
                        state.saleCatgUseTcoinMap?.[p.saleCatgSlctCode] === 'Y'
                );
                const canOnlyUseCrdtPntAmt = canOnlyUseCrdtPntProdList
                    .map(p => p.prodUnitPrcAmt * p.prodOrdQty)
                    .reduce((a, c) => a + c, 0);
                return Math.floor(
                    (earnLuckydrawPymtAmt +
                        Math.min(
                            canOnlyUseCrdtPntAmt - getters.crdtPntDsctAmt,
                            0
                        )) /
                        50
                );
            };
        },
        rdmGiftProdList(state) {
            const shoppingList = state.rdmGiftShopList;
            return shoppingList ? shoppingList.shopListProdList : [];
        },
        isRdmGiftShopListOpen() {
            return true;
        },
        rdmGiftRoute(state, getters) {
            return prodCatgSlctKey => {
                let params = {
                    prodCatgSlctKey
                };
                if (getters.previewCmpyToken) {
                    return {
                        name: 'previewRdmGift',
                        params: {
                            ...params,
                            cmpyToken: getters.previewCmpyToken
                        }
                    };
                }
                return {
                    name: 'rdmGift',
                    params: {
                        ...params
                    }
                };
            };
        },
        rdmGiftProductRoute(state, getters) {
            return id => {
                let params = {
                    id
                };
                if (getters.previewCmpyToken) {
                    return {
                        name: 'previewRdmGiftProduct',
                        params: {
                            ...params,
                            cmpyToken: getters.previewCmpyToken
                        }
                    };
                }
                return {
                    name: 'rdmGiftProduct',
                    params: {
                        ...params
                    }
                };
            };
        },
        hasActivePrmtEvnt(state) {
            const today = new Date();
            return state.promotionEvents.some(evnt => {
                let prmtEvntBgnDate = new Date(evnt.prmtEvntBgnDate);
                let prmtEvntEndDate = new Date(evnt.prmtEvntEndDate);
                // add 1 day for checking with <
                prmtEvntEndDate = prmtEvntEndDate.setDate(
                    prmtEvntEndDate.getDate() + 1
                );
                return today > prmtEvntBgnDate && today < prmtEvntEndDate;
            });
        }
    },
    actions: {
        async loadMain(ctx) {
            try {
                let [result] = await Promise.all([
                    instance.get('/api/main'),
                    new Promise(rs => setTimeout(rs, 1000))
                ]);
                ctx.commit('setUser', result.data.user);
                ctx.commit('setUserData', result.data);
                ctx.commit('setPromotionCampaignStatus', result.data);
                ctx.commit('setPromotionEvents', result.data.promotionEvents);
                ctx.commit('setBofUser', result.data.bofUser);
                ctx.commit('setProfiles', result.data.profiles);
                ctx.commit(
                    'setDfltRcvCrdtPntUnitPchsAmt',
                    result.data.dfltRcvCrdtPntUnitPchsAmt
                );
                ctx.commit(
                    'setDfltRcvCrdtPntUnitQty',
                    result.data.dfltRcvCrdtPntUnitQty
                );
                ctx.commit(
                    'setDfltSpendCrdtPntUnitQty',
                    result.data.dfltSpendCrdtPntUnitQty
                );
                ctx.commit(
                    'setDfltSpendCrdtPntUnitDsctAmt',
                    result.data.dfltSpendCrdtPntUnitDsctAmt
                );
                ctx.commit(
                    'setFriendAccountMaxProdKinds',
                    result.data.friendAccountMaxProdKinds
                );
                ctx.commit(
                    'setSalesEndCountDownHour',
                    result.data.salesEndCountDownHour
                );
                ctx.commit(
                    'setEnableCreditPoint',
                    result.data.enableCreditPoint
                );
                ctx.commit('setRecaptchaSiteKey', result.data.recaptchaSiteKey);
                if (result.data.user) {
                    sessionTimer.refresh();
                    marketingDataProcessor.start();
                }
            } catch (e) {
                /* eslint-disable no-console */
                console.error('cannot loadMain');
                ctx.commit('clearSession');
            }
        },
        async oauth(ctx, { token, clientId }) {
            try {
                await instance.post(
                    '/api/oauth',
                    qs.stringify({
                        jwt: token,
                        clientId: clientId
                    }),
                    {
                        headers: {
                            'Content-Type':
                                'application/x-www-form-urlencoded;charset=utf-8'
                        }
                    }
                );
            } catch (e) {
                /* eslint-disable no-console */
                console.error('cannot oauth');
            }
        },
        async getShoppingCartList(ctx) {
            try {
                let result = await instance.get('/api/shoppingCart/getAll', {});
                if (result.data.success) {
                    ctx.commit(
                        'setCartItems',
                        result.data.data.shoppingCartList
                    );
                    ctx.commit('setPromotionCampaignStatus', result.data.data);
                    if (result.data.data.shoppingList) {
                        ctx.commit(
                            'setShoppingList',
                            result.data.data.shoppingList
                        );
                    }
                    if (result.data.data.purchasedProductKeys) {
                        ctx.commit(
                            'setPurchasedProductKeys',
                            result.data.data.purchasedProductKeys
                        );
                    }
                    return result.data.data.shoppingCartList;
                }
            } catch (e) {
                /* eslint-disable no-console */
                console.error('error getting shopping cart list');
            }
            return undefined;
        },
        async getProductFeedbacks() {
            let result = await instance.get(
                '/api/productFeedback/getProdFdbkList'
            );
            return result.data;
        },
        async getProductFeedbacksByToken(ctx, prodFdbkEmailTknNum) {
            let result = await instance.get(
                '/api/productFeedback/getProdFdbkListByToken',
                {
                    params: { prodFdbkEmailTknNum }
                }
            );
            return result.data;
        },
        async getCouponList(ctx) {
            try {
                let result = await instance.get('/api/cpn/getAll', {});
                if (result.data.success) {
                    ctx.commit('setCpnList', result.data.data.couponList);
                    return result.data.data.couponList;
                }
            } catch (e) {
                /* eslint-disable no-console */
                console.error('error getting coupon list');
            }
            return undefined;
        },
        async getPromotionEventList(ctx) {
            try {
                let result = await instance.get('/api/event/getAll', {});
                if (result.data.success) {
                    ctx.commit(
                        'setPromotionEvents',
                        result.data.data.promotionEvents
                    );
                    return result.data.data.promotionEvents;
                }
            } catch (e) {
                /* eslint-disable no-console */
                console.error('error getting promotion event list');
            }
            return undefined;
        },
        async getCreditPointBalance(ctx) {
            try {
                let result = await instance.get(
                    '/api/crdtPnt/getTotalBalance',
                    {}
                );
                if (result.data.success) {
                    ctx.commit(
                        'setCrdtPntBal',
                        result.data.data.creditPointBalance
                    );
                    return result.data.data.creditPointBalance;
                }
            } catch (e) {
                /* eslint-disable no-console */
                console.error('error getting credit point balance');
            }
            return undefined;
        },
        async getPreviewProducts(ctx, cmpyTkn) {
            try {
                let result = await instance.get(
                    '/api/previewProducts/' + cmpyTkn
                );
                if (result.data) {
                    ctx.commit('setUserData', result.data);
                }
                return result.data;
            } catch (e) {
                /* eslint-disable no-console */
                console.error('cannot get preview products');
            }
        },
        async getPreviewShoppingList(ctx, shopListKey) {
            try {
                let result = await instance.get(
                    `/api/previewShoppingList/${shopListKey}`
                );
                if (result.data) {
                    ctx.commit(
                        'setShoppingListPreviewedById',
                        result.data.shoppingList
                    );
                    ctx.commit('setUserData', result.data);
                }
                return result.data;
            } catch (e) {
                /* eslint-disable no-console */
                console.error(
                    'cannot get preview shopping list by shopListKey'
                );
            }
        },
        async login(ctx, data) {
            try {
                let result = await instance.post('/api/login', data);
                if (result.data.success) {
                    ctx.commit('setUser', result.data.data.user);
                    ctx.commit('setUserData', result.data.data);
                    ctx.commit('setPromotionCampaignStatus', result.data.data);
                    ctx.commit(
                        'setPromotionEvents',
                        result.data.data.promotionEvents
                    );
                    ctx.commit('setPreviewCmpy', undefined);
                    ctx.commit('setBofUser', undefined);
                }
                sessionTimer.refresh();
                marketingDataProcessor.start();
                return result.data;
            } catch (e) {
                return { success: false, messageKey: 'error.connect' };
            }
        },
        async bofLogin(ctx, data) {
            try {
                let result = await instance.post(
                    '/api/quickJoinCmpy/bofLogin',
                    data
                );
                if (result.data.success) {
                    sessionTimer.destroy();
                    ctx.commit('clearSession');
                    ctx.commit('setBofUser', result.data.data.bofUser);
                }
                return result.data;
            } catch (e) {
                return { success: false, messageKey: 'error.connect' };
            }
        },
        async logout(ctx) {
            let result = await instance.post('/api/logout');
            if (result.data.success) {
                sessionTimer.destroy();
                marketingDataProcessor.destroy();

                ctx.commit('clearSession');
            }
            return result.data;
        },
        async getAccountInfo(ctx) {
            let result = await instance.get('/api/accountInfo/get');
            if (result.data.success) {
                ctx.commit('setUser', result.data.data.user);
            }
        },
        async getIsAccountInfoCompleted() {
            try {
                let result = await instance.get(
                    '/api/accountInfo/checkIsInfoCompleted'
                );
                return result.data.data.isInfoCompleted;
            } catch (e) {
                /*eslint-disable no-console*/
                console.error('error getting isInfoCompleted');
            }
            return false;
        },
        async saveCustProdViewHist(ctx, shopListProd) {
            try {
                let result = await instance.post(
                    '/api/product/saveCustProdViewHist',
                    shopListProd
                );
                return result.data;
            } catch (e) {
                return { success: false, errors: { error: 'error.server' } };
            }
        },
        async insertUpdateServerCart(ctx, { shopListProdKey, prodOrdQty }) {
            try {
                let result = await instance.put('/api/shoppingCart/save', {
                    shopListProdKey: shopListProdKey,
                    prodOrdQty: prodOrdQty
                });
                if (result.data.success) {
                    return result.data.data.shopCart;
                }
            } catch (e) {
                //console.log('error setting server cart');
            }
            return undefined;
        },
        async setCartProduct(ctx, { shopListProdKey, prodOrdQty, isAdd }) {
            try {
                const items = ctx.state.cartItems;
                const idx = items.findIndex(
                    c => c.shopListProdKey === shopListProdKey
                );

                let updProdOrdQty;
                if (idx !== -1) {
                    updProdOrdQty = isAdd
                        ? items[idx].prodOrdQty + prodOrdQty
                        : items[idx].prodOrdQty;
                } else {
                    updProdOrdQty = prodOrdQty;
                }

                let result = await instance.put('/api/shoppingCart/save', {
                    shopListProdKey: shopListProdKey,
                    prodOrdQty: updProdOrdQty
                });

                if (result.data.success) {
                    let list;
                    if (idx !== -1) {
                        list = items.map((p, pi) => {
                            if (pi === idx) {
                                return {
                                    ...result.data.data.shopCart
                                };
                            }
                            return p;
                        });
                    } else {
                        list = items.concat([{ ...result.data.data.shopCart }]);
                    }
                    ctx.commit('setCartItems', list);
                    ctx.commit('setLastAddedCartItem', {
                        ...result.data.data.shopCart
                    });

                    return { success: true };
                }
            } catch (e) {
                //console.log('error setting cart product');
            }
            return { success: false };
        },
        async deleteCartProduct(ctx, cartId) {
            try {
                ctx.commit(
                    'setCartItems',
                    ctx.state.cartItems.filter(c => c.id !== cartId)
                );
                let result = await instance.delete(
                    '/api/shoppingCart/delete/' + cartId
                );
                if (result.data.success) {
                    return true;
                }
            } catch (e) {
                //console.log('error deleting cart product');
            }
            return false;
        },
        async updateOrRemoveExcessMaxQtyCartProduct(ctx) {
            try {
                let cartItems = ctx.state.cartItems;
                cartItems.forEach(i => {
                    const maxOrdQty = ctx.getters.getProductMaxOrdQtyPerPerson(
                        i
                    );
                    const {
                        totalBoughtQty,
                        rmnProdQty,
                        stckAvailQty,
                        pgsProdSaleQtyInd,
                        pgsProdQty,
                        maxProdSaleQty,
                        prodUnitPrcAmt,
                        chkProdInvtryInd
                    } = i;
                    if (maxOrdQty) {
                        i.prodOrdQty = Math.max(
                            Math.min(i.prodOrdQty, maxOrdQty - totalBoughtQty),
                            0
                        );
                    }
                    if (chkProdInvtryInd !== 'N') {
                        i.prodOrdQty = Math.max(
                            Math.min(i.prodOrdQty, stckAvailQty),
                            0
                        );
                    }
                    if (pgsProdSaleQtyInd === 'Y') {
                        i.prodOrdQty = Math.max(
                            Math.min(
                                i.prodOrdQty,
                                rmnProdQty + pgsProdQty - maxProdSaleQty
                            ),
                            0
                        );
                    }
                    if (
                        maxProdSaleQty !== undefined &&
                        maxProdSaleQty !== null
                    ) {
                        i.prodOrdQty = Math.max(
                            Math.min(i.prodOrdQty, rmnProdQty),
                            0
                        );
                    }
                    if (
                        prodUnitPrcAmt === undefined ||
                        prodUnitPrcAmt === null
                    ) {
                        i.prodOrdQty = 0;
                    }
                });
                cartItems = cartItems.filter(i => i.prodOrdQty > 0);
                ctx.commit('setCartItems', cartItems);

                let result = await instance.post(
                    '/api/shoppingCart/updateCarts/',
                    cartItems
                );

                if (result.data.success) {
                    return true;
                }
            } catch (e) {
                //console.log('error update or remove excess max qty cart product)
            }
            return false;
        },
        async createOrder(
            ctx,
            {
                shopCarts,
                cmpySiteKey,
                cpnKey,
                spendCrdtPntQty,
                custDlvrAddrForm
            }
        ) {
            try {
                let result = await instance.post('/api/shoppingCart/checkout', {
                    shopCarts: shopCarts,
                    cmpySiteKey: cmpySiteKey,
                    cpnKey: cpnKey || null,
                    spendCrdtPntQty: spendCrdtPntQty || null,
                    custDlvrAddrForm: custDlvrAddrForm
                });

                return result.data;
            } catch (e) {
                /*eslint-disable no-console*/
                console.error('error checkout');
            }
            return undefined;
        },
        async cancelOrder(ctx, saleOrdTxnNum) {
            let result = await instance.delete(
                '/api/order/id/' + saleOrdTxnNum
            );
            return result.data;
        },
        async createPayment(
            ctx,
            { saleOrdTxnNum, pymtSrvcPrvdId, pymtMthdId }
        ) {
            let result = await instance.post('/api/payment/createPayment', {
                saleOrdTxnNum: saleOrdTxnNum,
                pymtSrvcPrvdId: pymtSrvcPrvdId,
                pymtMthdId: pymtMthdId
            });
            return result.data;
        },
        async createTestPayment(ctx, { pymtSrvcPrvdId, pymtMthdId }) {
            let result = await instance.post('/api/demo/mpay/createPayment', {
                pymtSrvcPrvdId: pymtSrvcPrvdId,
                pymtMthdId: pymtMthdId
            });
            return result.data;
        },
        async createSingleTxnEnquiry(ctx, { saleOrdTxnNum }) {
            let result = await instance.get(
                '/api/demo/mpay/enquirySingleTransaction',
                {
                    params: { saleOrdTxnNum }
                }
            );
            return result.data;
        },
        async createMPayTxnRptEnquiry() {
            let result = await instance.get(
                '/api/demo/mpay/enquiryTransactionReport'
            );
            return result.data;
        },
        async loadOrderList(ctx, ordHistWithinDays) {
            ctx.commit('setOrderList', []);
            let result = await instance.get('/api/order/list', {
                params: { ordHistWithinDays }
            });
            ctx.commit('setOrderList', result.data.data.orderList);
        },
        async loadEventTicketList(ctx) {
            ctx.commit('setEventTicketList', []);
            let result = await instance.get('/api/eventTicket/list');
            ctx.commit('setEventTicketList', result.data.data.eventTicketList);
        },
        async loadCrdtPntHistList(ctx) {
            ctx.commit('setCrdtPntHistList', []);
            let result = await instance.get('/api/crdtPnt/getCrdtPntTxnList');
            ctx.commit(
                'setCrdtPntHistList',
                result.data.data.creditPointTransactions
            );
        },
        async loadCustPrzHistList(ctx, przHistWithinDays) {
            ctx.commit('setCustPrzHistList', []);
            let result = await instance.get('/api/event/getCustPrzHistList', {
                params: { przHistWithinDays }
            });
            ctx.commit(
                'setCustPrzHistList',
                result.data.data.customerPrizeHistoryList
            );
        },
        async getOrderDetails(ctx, orderNo) {
            let order = await instance.get('/api/order/id/' + orderNo);
            return order.data.data.salesOrder;
        },
        async changePassword(ctx, data) {
            let result = await instance.post('/api/demoChangePassword', data);
            return result.data;
        },
        updateCreditPointDiscountAmount(ctx, { crdtPntDsctAmt }) {
            ctx.commit(
                'setCreditPoint',
                Math.floor(
                    crdtPntDsctAmt / ctx.getters.spendCrdtPntUnitDsctAmt
                ) * ctx.getters.spendCrdtPntUnitQty
            );
        },
        async redeemGift(ctx, { shopListProdKey, prodOrdQty }) {
            let result = await instance.put('/api/rdmGift/rdmGift', {
                shopListProdKey: shopListProdKey,
                prodOrdQty: prodOrdQty
            });

            return result.data;
        },
        async getRdmGiftShopList(ctx) {
            try {
                let result = await instance.get(
                    '/api/rdmGift/getRdmGiftShopList',
                    {}
                );
                if (result.data.success) {
                    ctx.commit(
                        'setRdmGiftShopList',
                        result.data.data.rdmGiftShopList
                    );
                }
            } catch (e) {
                /* eslint-disable no-console */
                console.error('error getting shopping cart list');
            }
            return undefined;
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setUserData(state, data) {
            state.shoppingList = data.shoppingList;
            state.advertisementList = data.advertisementList;
            state.videoAdvertisementList = data.videoAdvertisementList;
            state.cartItems = data.shoppingCartList || [];
            state.cpnList = data.couponList || [];
            state.orderList = data.orderList;
            state.companySiteList = data.companySiteList;
            state.companyPaymentMethodList = data.companyPaymentMethodList;
            state.enableReferral = data.enableReferral;
            state.enableReferralTcoinAward = data.enableReferralTcoinAward;
            state.enableWelcomeTcoinAward = data.enableWelcomeTcoinAward;
            state.enableBirthdayTcoinAward = data.enableBirthdayTcoinAward;
            state.announcement = data.announcement;
            state.previewCmpy = data.company;
            state.teamnoteClientName = data.teamnoteClientName;
            state.crdtPntBal = data.creditPointBalance || 0;
            state.saleCatgRefPrcNameMap = data.saleCatgRefPrcNameMap;
            state.saleCatgUnitPrcNameMap = data.saleCatgUnitPrcNameMap;
            state.saleCatgUseTcoinMap = data.saleCatgUseTcoinMap;
            state.saleCatgPayCashMap = data.saleCatgPayCashMap;
            state.luckydraw2021IndMap = data.luckydraw2021IndMap;
            state.showProdCatgFltr = data.showProdCatgFltr;
            state.prodCatgList = data.prodCatgList;
            state.geogAreaList = data.geogAreaList;
            state.rdmGiftShopList = data.rdmGiftShopList;
            state.enblRdmGift = data.enblRdmGift;
            state.enblCreAcct = data.enblCreAcct;

            saleEndDateTimer.updateSaleEndDateCountdown(
                state,
                data.shoppingList
            );
        },
        setPromotionCampaignStatus(state, data) {
            state.promotionCampaigns.promotionCampaignCny2021Status =
                data.promotionCampaignCny2021Status;
            state.promotionCampaigns.promotionCampaignCny2021FreeSampleCount =
                data.promotionCampaignCny2021FreeSampleCount;
        },
        setBofUser(state, bofUser) {
            state.bofUser = bofUser;
        },
        setPreviewCmpy(state, val) {
            state.previewCmpy = val;
        },
        setShoppingListPreviewedById(state, val) {
            state.shoppingListPreviewedById = val;
        },
        setProfiles(state, profiles) {
            state.profiles = profiles;
        },
        setDfltRcvCrdtPntUnitPchsAmt(state, dfltRcvCrdtPntUnitPchsAmt) {
            state.dfltRcvCrdtPntUnitPchsAmt = dfltRcvCrdtPntUnitPchsAmt;
        },
        setDfltRcvCrdtPntUnitQty(state, dfltRcvCrdtPntUnitQty) {
            state.dfltRcvCrdtPntUnitQty = dfltRcvCrdtPntUnitQty;
        },
        setDfltSpendCrdtPntUnitQty(state, dfltSpendCrdtPntUnitQty) {
            state.dfltSpendCrdtPntUnitQty = dfltSpendCrdtPntUnitQty;
        },
        setDfltSpendCrdtPntUnitDsctAmt(state, dfltSpendCrdtPntUnitDsctAmt) {
            state.dfltSpendCrdtPntUnitDsctAmt = dfltSpendCrdtPntUnitDsctAmt;
        },
        setFriendAccountMaxProdKinds(state, val) {
            state.friendAccountMaxProdKinds = val;
        },
        setSalesEndCountDownHour(state, val) {
            state.salesEndCountDownHour = val;
        },
        setPurchasedProductKeys(state, val) {
            state.purchasedProductKeys = val || [];
        },
        setShoppingList(state, val) {
            state.shoppingList = val;
        },
        setAdvertisementList(state, val) {
            state.advertisementList = val;
        },
        setVideoAdvertisementList(state, val) {
            state.videoAdvertisementList = val;
        },
        setCartItems(state, val) {
            state.cartItems = val || [];
        },
        setLastAddedCartItem(state, val) {
            state.lastAddedCartItem = val;
        },
        setCpnList(state, val) {
            state.cpnList = val || [];
        },
        setCrdtPntBal(state, val) {
            state.crdtPntBal = val || 0;
        },
        setUseCoupon(state, val) {
            state.useCoupon = val;
        },
        setUseCreditPoint(state, val) {
            state.useCreditPoint = val;
        },
        setCpn(state, val) {
            state.cpn = val;
        },
        setCreditPoint(state, val) {
            state.creditPoint = val;
        },
        setOrderList(state, val) {
            state.orderList = val;
        },
        setEventTicketList(state, val) {
            state.eventTicketList = val;
        },
        setOrderToOrderList(state, order) {
            const idx = state.orderList.findIndex(o => o.id === order.id);
            if (idx !== -1) {
                state.orderList = state.orderList.map((o, oi) => {
                    if (oi === idx) {
                        return {
                            ...o,
                            ...order
                        };
                    }
                    return o;
                });
            } else {
                state.orderList.push(order);
            }
        },
        setCrdtPntHistList(state, val) {
            state.crdtPntHistList = val;
        },
        setCompanySiteList(state, val) {
            state.companySiteList = val;
        },
        setCompanyPaymentMethodList(state, val) {
            state.companyPaymentMethodList = val;
        },
        setEnableCreditPoint(state, val) {
            state.enableCreditPoint = val;
        },
        setShowLoginRegisterModal(state, val) {
            state.showLoginRegisterModal = val;
        },
        setRecaptchaSiteKey(state, val) {
            state.recaptchaSiteKey = val;
        },
        setPopupAdvertisement(state, val) {
            state.popupAdvertisement = val;
        },
        setShowConfirmPhoneNumber(state, val) {
            state.showConfirmPhoneNumber = val;
        },
        setPromotionEvents(state, val) {
            state.promotionEvents = val || [];
        },
        setPromotionEventRemainingToken(state, { eventId, remainingToken }) {
            const event = (state.promotionEvents || []).find(
                p => p.prmtEvntId === eventId
            );
            if (event) {
                event.custTknCnt = remainingToken;
            }
        },
        setCustPrzHistList(state, val) {
            state.custPrzHistList = val;
        },
        setRdmGiftShopList(state, val) {
            state.rdmGiftShopList = val;
        },
        setFpsData(state, data) {
            state.fpsQrCode = data.fpsQrCode;
            state.fpsCurrentOrdNo = data.fpsCurrentOrdNo;
            state.fpsCurrentOrdKey = data.fpsCurrentOrdKey;
            state.fpsPymtAmt = data.fpsPymtAmt;
        },
        clearSession(state) {
            state.user = undefined;
            state.bofUser = undefined;
            state.cartItems = [];
            state.lastAddedCartItem = undefined;
            state.shoppingList = undefined;
            state.shoppingListPreviewedById = undefined;
            state.advertisementList = undefined;
            state.videoAdvertisementList = undefined;
            state.orderList = [];
            state.companySiteList = [];
            state.companyPaymentMethodList = [];
            state.enableReferral = false;
            state.enableReferralTcoinAward = false;
            state.enableWelcomeTcoinAward = false;
            state.enableBirthdayTcoinAward = false;
            state.rdmGiftShopList = undefined;

            saleEndDateTimer.clearSaleEndDateCountdown(state);
        }
    },
    modules: {}
});
